'use client';
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";
import { useEffect } from "react";

export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("haut-conseil-des-transporteurs");

    return (
        <PostContentFallback>
            <article>
                {currentPost && (
                    <div style={{ backgroundImage: `url(${currentPost.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                        <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                            <SectionPage sectionType={"2xl"}>
                                <h1 className={"text-white text-4xl font-exo"}>{currentPost.title}</h1>
                            </SectionPage>
                        </div>
                    </div>
                )}

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <h1 className="text-3xl font-bold font-exo text-rose mt-8 mb-4">La promotion de la Destination Côte d’Ivoire au centre d’échanges entre Côte d’Ivoire Tourisme et le Haut Conseil du Patronat des Entreprises de Transport Routier</h1>


                        <p className="my-4 text-normal leading-relaxed">
                            Le Directeur Général de Côte d’Ivoire Tourisme a échangé ce Mardi 12 Septembre avec le Haut Conseil du Patronat des Entreprises de Transport Routier.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Pour Madame Malékah MOURAD-CONDE, cette rencontre vise à sensibiliser les acteurs du transport en vue d’une amélioration continue de la qualité de leurs services afin de mieux répondre aux attentes des touristes internes et externes.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Une initiative que salue l’Organisation des Transporteurs représentée par son Directeur Général Adjoint, M. Salif SAMAKE.
                        </p>
                    </div>


                    <div className={'mt-8'}>
                        <ImageGallery images={
                            Array.from({ length: 6 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/gallerie/${index + 1}.png`,
                                alt: `image${index + 1}`,
                                width: 700,
                                height: 700,
                            }))
                        } aspectRatio={"video"} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
